/**
 * Global styles can't have stories
 */
/* eslint-disable local-rules/require-storybook-documentation */
import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
    body {
        margin: 0
    }
`;
